// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2018":"abcb7b90","2746":"3b775434","6346":"b72a8383","6865":"3b775434"}[chunkId] + ".chunk.css";
};